import { AfterViewInit, Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { CheckboxChangeEvent } from 'primeng/checkbox';
import { ButtonFilterService } from '../../services/button-filter.service';
import { filter } from 'rxjs';
import { OverlayPanel } from 'primeng/overlaypanel';

@Component({
  selector: 'split-button-filter',
  templateUrl: './split-button-filter.component.html',
  styleUrls: ['./split-button-filter.component.scss']
})
export class SplitButtonFilterComponent implements OnChanges, OnInit {

  @Input() filter!: IFilterModel;

  @Output() filterChange: EventEmitter<IFilterModel> = new EventEmitter();


  public _filter!: IFilterModel;

  @ViewChild('op') public overlayPanel!: OverlayPanel;

  isActiveOverlay: boolean = false;



  constructor(private buttonFilterService: ButtonFilterService) {}
  ngOnInit(): void {
    this.buttonFilterService.filterSubject
    .pipe(
      filter(
        (payload) => (payload?.filter && (payload?.filter.id == this._filter.id)) || payload.action == "CLEAR"
      )
    ).subscribe(
      (payload) => {
        switch(payload.action) {
          case 'REMOVE': 
            if(this._filter.type == "DROPDOWN") {
              let optionIndex = this._filter.data.findIndex(data => data.code == payload.data.code);
              this._filter.data[optionIndex].checklist = false;
            } else {
              this._filter.data = [];
            }
          break;
          case 'CLEAR': 
            if(this._filter.type == "DROPDOWN") {
              this._filter.data = this._filter.data.map(data => ({...data, checklist: false}));
            } else {
              this._filter.data = [];
            }
          break;
        }
        this.emit();
      }
    )
  }
  ngOnChanges(changes: SimpleChanges): void {
    if(changes['filter']) {
      this._filter = new FilterModel(this.filter);
    }
  }

  change(event: CheckboxChangeEvent, position: any = undefined) {
    this._filter.data[position].checklist = !this._filter.data[position].checklist;
  }

  inputDate(event: any, position: number) {
    let [day, month, year] = event.target.value.split('/');
    let date = new Date(year, (month - 1), day);
    if(this.isValidDate(date)) {
      this._filter.data[position] = date;
    }
  }

  isValidDate(date: Date){
    return date.toString() !== 'Invalid Date';
  }

  cancel() {
    this._filter.data = [];
  }

  emit() {
    this.filter = new FilterModel(this._filter);
    this.filterChange.emit(this.filter);
    this.overlayPanel.hide();
  }
  search(event: any) {
    this._filter.data = this.filter.data.filter(option => {
      return option.value.toLowerCase().indexOf(event) > -1;
    });
  }

  hideOverlayPanel() {
    this._filter.data = 
      this._filter.type == 'DATE' 
      ? this.filter.data.length <= 0 ? [] : this.filter.data
      : this._filter.data.map((data, index) => ({...data, checklist: this.filter.data[index].checklist ?? false}));
      this.isActiveOverlay = false;
  }

  showOverlayPanel(event: any) {
    this.overlayPanel.show(event);
    this.isActiveOverlay = true;
  }

  /*@Input() public type!: string;
  @Input() public options!: Array<any>;
  @Input() public id!: string;


  @Output() changeSelected: EventEmitter<any> = new EventEmitter(); 

  @Input() public selected: FilterModel = new FilterModel();


  public optionsFilter: Array<any> = [];

  constructor(private buttonFilterService: ButtonFilterService) {
    this.buttonFilterService.filterSubject
        .pipe(
          filter(
            (payload) => (payload.id == this.id) || payload.action == "CLEAR"
          )
        ).subscribe(
          (payload) => {
            switch(payload.action) {
              case 'REMOVE': 
                if(this.options) {
                  console.log(this.selected.data);
                  let optionIndex = this.selected.data.findIndex(data => data.option.code == payload.data.code);
                  console.log(optionIndex);
                  this.selected.data[optionIndex].checklist = false;
                  this.emit();
                }
              break;
              case 'CLEAR': 
                this.clear();
                this.emit();
              break;
            }
          }
        )

  }

  ngOnInit(): void {
    console.log(this.selected)
  }

  ngOnChanges(changes: SimpleChanges): void {
    let data: any[] = [];
    if(changes['options']) {
      data = this.options.map(
        (option) => ({option, checklist: false})
      );

      this.optionsFilter = this.options;
    }

    this.selected = new FilterModel(<IFilterModel>{
      id: this.id,
      type: this.type,
      data
    });

    //this.emit();

    if(changes['selected']) {
      console.log(this.selected);
      if(typeof this.selected == "undefined") {
        this.selected = new FilterModel(<IFilterModel>{
          id: this.id,
          type: this.type,
          data: []
        });
      }
    }


  }


  change(event: CheckboxChangeEvent, position: any = undefined) {
      if(this.selected.data.length <= 0) {
        this.selected = new FilterModel(<IFilterModel>{
          id: this.id,
          type: this.type,
          data: this.options.map(
            (option) => ({option, checklist: false})
          )
        });
      }
      this.selected.data[position].checklist = !this.selected.data[position].checklist;
  }

  configDate(event: any, position: number) {
    let [day, month, year] = event.target.value.split('/');
    let date = new Date(year, (month - 1), day);
    if(this.isValidDate(date)) {
      this.selected.data[position] = date;
    }
  }

  isValidDate(date: Date){
    return date.toString() !== 'Invalid Date';
  }

  clear() {
    if(this.type == "DATE") {
      this.selected.data = [];
    } else {
      this.selected.data = this.options.map(
        (option) => ({option, checklist: false})
      );
    }
  }

  cancel() {
    this.selected.data = [];
  }

  emit() {
    if(this.type == "DROPDOWN") {
      this.selected.data = this.selected.data.filter((data: any) => data.checklist);
    }
    this.changeSelected.emit(this.selected);
  }

  search(event: any) {
    this.optionsFilter = this.options.filter(option => {
      return option.value.toLowerCase().indexOf(event) > -1;
    });
  }*/
}


export class FilterModel implements IFilterModel {
  public id!: string;
  public type!: string;
  public name!: string;
  public data: any[] = [];
  
  constructor(payload: IFilterModel | undefined = undefined) {
    if(payload) {
      this.id = payload.id;
      this.name = payload.name;
      this.type = payload.type;
      this.data = payload?.data?.map(data => data?.constructor?.name == "Object" ? Object.assign({}, data) : data);
    }
  }
}


export interface IFilterModel {
   id: string;
   type: string;
   name: string
   data: any[];
}